import { Suspense, lazy } from 'react';

import type { DailySpendProps } from './DailySpend';

/**
 * `@visx/*` must stay out of the entry bundle — this is the one place that boundary is
 * drawn for the usage figures (constitution Principle 6, spec 076 FR-032).
 *
 * The boundary matters less than the guard on it: `scripts/check-bundle.sh` asserts by
 * name that `@visx` reaches no chunk the entry includes, and it reads the module graph
 * through the chunk's sourcemap rather than matching class names — because `@visx/scale`
 * renders nothing and emits no class name to match.
 *
 * The fallback mirrors the real card so nothing shifts when the module resolves.
 */
const DailySpend = lazy(() =>
  import('./DailySpend').then((module) => ({ default: module.DailySpend })),
);

function DailySpendFallback() {
  return (
    <section className="flex flex-col gap-3" aria-hidden="true">
      <div className="bg-muted h-3 w-16 rounded-sm" />
      <div className="border-border bg-card rounded-lg border px-4 py-3.5">
        <div className="bg-muted/40 h-[150px] w-full animate-pulse rounded-md" />
      </div>
    </section>
  );
}

export function DailySpendLazy(props: DailySpendProps) {
  return (
    <Suspense fallback={<DailySpendFallback />}>
      <DailySpend {...props} />
    </Suspense>
  );
}
